import { RenterStateTypes, RenterActionTypes } from "./Renter.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: RenterStateTypes = {
  fetchAll: resetApiCallState([]),
};

const RenterReducer = (
  state: RenterStateTypes = INITIAL_STATE,
  action: any
): RenterStateTypes => {
  switch (action.type) {
    case RenterActionTypes.FETCH_ALL_RENTER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case RenterActionTypes.FETCH_ALL_RENTER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case RenterActionTypes.FETCH_ALL_RENTER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RenterActionTypes.FETCH_ALL_RENTER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default RenterReducer;
